import { SyncDiff } from '@constants/profiles';

export const RESOLVE_ORIGIN = { LOCAL: 0, SYNC: 1, IGNORE: 2 };

export const countResolvableDiffs = diffs => (diffs ?? []).filter(d => d !== SyncDiff.NotPublished).length;

export const seedResolveSelections = (currentDiff = [], ignoredDiff = []) =>
    currentDiff.reduce(
        (acc, cur) => ({ ...acc, [cur]: ignoredDiff.includes(cur) ? RESOLVE_ORIGIN.IGNORE : undefined }),
        {},
    );

export const combineResolveSelections = ({ selections, currentDiff = [] }) =>
    Object.fromEntries(
        Object.entries(selections).filter(
            ([field, origin]) => origin !== undefined && currentDiff.includes(Number(field)),
        ),
    );
